export const PATH = {
  OVERVIEW: 'overview',
  EDIT: 'edit',
}

export const addressBookLinks = {
  addressBookOverviewLink: () => `/${PATH.OVERVIEW}`,
  addressBookEntryFormLink: ({ addressId }: { addressId: string }) => `/${PATH.EDIT}?addressId=${addressId}`,
}
